
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import BookingSection from '../home/components/BookingSection';
import PaymentSection from '../home/components/PaymentSection';

export default function BookingPage() {
  const [currentStep, setCurrentStep] = useState<'booking' | 'payment' | 'confirmation'>('booking');
  const [bookingData, setBookingData] = useState<any>(null);

  const handleBookingComplete = (data: any) => {
    setBookingData(data);
    setCurrentStep('payment');
  };

  const handlePaymentSuccess = () => {
    setCurrentStep('confirmation');
  };

  const handleBackToBooking = () => {
    setCurrentStep('booking');
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Progress Indicator */}
      <div className="bg-gray-50 py-6">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center space-x-8">
            <div className={`flex items-center ${currentStep === 'booking' ? 'text-blue-600' : currentStep === 'payment' || currentStep === 'confirmation' ? 'text-green-600' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${currentStep === 'booking' ? 'bg-blue-600 text-white' : currentStep === 'payment' || currentStep === 'confirmation' ? 'bg-green-600 text-white' : 'bg-gray-300 text-gray-600'}`}>
                {currentStep === 'payment' || currentStep === 'confirmation' ? (
                  <i className="ri-check-line"></i>
                ) : (
                  <span>1</span>
                )}
              </div>
              <span className="ml-2 font-medium">Booking Details</span>
            </div>
            
            <div className={`w-16 h-0.5 ${currentStep === 'payment' || currentStep === 'confirmation' ? 'bg-green-600' : 'bg-gray-300'}`}></div>
            
            <div className={`flex items-center ${currentStep === 'payment' ? 'text-blue-600' : currentStep === 'confirmation' ? 'text-green-600' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${currentStep === 'payment' ? 'bg-blue-600 text-white' : currentStep === 'confirmation' ? 'bg-green-600 text-white' : 'bg-gray-300 text-gray-600'}`}>
                {currentStep === 'confirmation' ? (
                  <i className="ri-check-line"></i>
                ) : (
                  <span>2</span>
                )}
              </div>
              <span className="ml-2 font-medium">Payment</span>
            </div>
            
            <div className={`w-16 h-0.5 ${currentStep === 'confirmation' ? 'bg-green-600' : 'bg-gray-300'}`}></div>
            
            <div className={`flex items-center ${currentStep === 'confirmation' ? 'text-green-600' : 'text-gray-400'}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${currentStep === 'confirmation' ? 'bg-green-600 text-white' : 'bg-gray-300 text-gray-600'}`}>
                {currentStep === 'confirmation' ? (
                  <i className="ri-check-line"></i>
                ) : (
                  <span>3</span>
                )}
              </div>
              <span className="ml-2 font-medium">Confirmation</span>
            </div>
          </div>
        </div>
      </div>

      <main>
        {currentStep === 'booking' && (
          <BookingSection onBookingComplete={handleBookingComplete} />
        )}
        
        {currentStep === 'payment' && bookingData && (
          <PaymentSection 
            bookingData={bookingData}
            onPaymentSuccess={handlePaymentSuccess}
            onBack={handleBackToBooking}
          />
        )}
        
        {currentStep === 'confirmation' && (
          <section className="py-20 bg-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
              <div className="bg-green-50 rounded-2xl p-12">
                <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-check-line text-3xl text-white"></i>
                </div>
                
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  Booking Confirmed!
                </h2>
                
                <p className="text-xl text-gray-600 mb-8">
                  Thank you for choosing KAILE BRIGHT! Your cleaning service has been successfully booked and paid for.
                </p>
                
                <div className="bg-white rounded-lg p-6 mb-8 text-left max-w-md mx-auto">
                  <h3 className="font-semibold text-gray-900 mb-4">Booking Details:</h3>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Service:</span>
                      <span className="font-medium">{bookingData?.service}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Date:</span>
                      <span className="font-medium">{bookingData?.date}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Time:</span>
                      <span className="font-medium">{bookingData?.time}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Address:</span>
                      <span className="font-medium">{bookingData?.address}</span>
                    </div>
                  </div>
                </div>
                
                <div className="space-y-4">
                  <p className="text-gray-600">
                    You will receive a confirmation email shortly with all the details.
                    Our team will arrive at your scheduled time ready to provide excellent service.
                  </p>
                  
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button 
                      onClick={() => window.location.href = '/'}
                      className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-home-line mr-2"></i>
                      Back to Home
                    </button>
                    
                    <button 
                      onClick={() => window.print()}
                      className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-printer-line mr-2"></i>
                      Print Receipt
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </main>
      
      <Footer />
    </div>
  );
}
